import { render, staticRenderFns } from "./CustomerService.vue?vue&type=template&id=1ea9679c"
import script from "./CustomerService.vue?vue&type=script&lang=js"
export * from "./CustomerService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ea9679c')) {
      api.createRecord('1ea9679c', component.options)
    } else {
      api.reload('1ea9679c', component.options)
    }
    module.hot.accept("./CustomerService.vue?vue&type=template&id=1ea9679c", function () {
      api.rerender('1ea9679c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/CustomerService.vue"
export default component.exports